import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import attribution_45global from "/app/middleware/attribution.global.ts";
import auth_45global from "/app/middleware/auth.global.ts";
import disable_45browser_45extension_45page_45in_45mobile_45global from "/app/middleware/disableBrowserExtensionPageInMobile.global.ts";
import ip_45block_45global from "/app/middleware/ipBlock.global.ts";
import redirect_45locale_45share_45link_45global from "/app/middleware/redirectLocaleShareLink.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  attribution_45global,
  auth_45global,
  disable_45browser_45extension_45page_45in_45mobile_45global,
  ip_45block_45global,
  redirect_45locale_45share_45link_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "activity-end": () => import("/app/middleware/activityEnd.ts"),
  "disable-mobile-platform-card-anchor": () => import("/app/middleware/disableMobilePlatformCardAnchor.ts"),
  "help-center-default-dir": () => import("/app/middleware/helpCenterDefaultDir.ts"),
  "redirect-faq-hash": () => import("/app/middleware/redirectFaqHash.ts"),
  share: () => import("/app/middleware/share.ts")
}